module.exports = __webpack_public_path__ + "img/lost_in_space.fe2c14a1.jpg";